import { render, staticRenderFns } from "./formKetcher.vue?vue&type=template&id=ccfbbfb6&"
import script from "./formKetcher.vue?vue&type=script&lang=js&"
export * from "./formKetcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports